module.exports = __webpack_public_path__ + "static/media/cancel-md-light.37dcb637.svg";